// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".damage-parts_part + .damage-parts_part {\n  margin-top: 3.2rem;\n}\n.damage-parts_part .damage-parts_part_piece + .damage-parts_part_piece {\n  margin-top: 2.4rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
